import { useState } from "react";
import { isEmpty } from "lodash";
import { toast } from "react-toastify";

import { useMutation, useQuery } from "@tanstack/react-query";
import { IconBuildings, IconChevronUp } from "@tabler/icons-react";

import {
  Divider,
  IconButton,
  ListItemIcon,
  Menu,
  MenuItem,
  Stack,
  Typography,
} from "@mui/material";

import { branchList, branchSwitch } from "../services/branches";

import { useUserStore } from "../stores/user";
import { formatCpfCnpj } from "../helpers/format";

const BranchSelect = ({ middleMenu }: { middleMenu: boolean }) => {
  const { user } = useUserStore();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const { setUser } = useUserStore();

  const { data } = useQuery({
    queryKey: ["branchListParentCompany"],
    queryFn: async () => await branchList({ parentCompany: true }),
    initialData: [],
  });

  const { mutate } = useMutation({
    mutationFn: branchSwitch,
    onSuccess: (data) => {
      localStorage.setItem("access_token", data?.access_token);
      setUser(data);

      window.location.href = "/dashboard";
    },
    onError: (e: { response: { data: { message: string } } }) => {
      toast.error(String(e?.response?.data?.message) || "Erro!");
    },
  });

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const onSelect = (parentCompany: number) => {
    mutate({ parentCompany });
    setAnchorEl(null);
  };

  const branchs = data.filter((s: any) => s.id !== user?.store?.id);
  return (
    <>
      {!isEmpty(branchs) && (
        <>
          {middleMenu ? (
            <IconButton
              sx={{ backgroundColor: "secondary.light" }}
              onClick={handleClick}
            >
              <IconChevronUp size={18} />
            </IconButton>
          ) : (
            <Stack
              sx={{
                flexDirection: "row",
                alignItems: "center",
                cursor: "pointer",
                gap: 1,
                justifyContent: "space-between",
                borderRadius: 5,
                paddingY: 1,
                paddingX: 2,

                backgroundColor: "secondary.light",
              }}
              onClick={handleClick}
            >
              <Stack
                sx={{ flexDirection: "row", alignItems: "center", gap: 2 }}
              >
                <Stack>
                  <Typography variant="body1" fontWeight={600}>
                    Filial: {user?.store?.name?.split(" ")[0]}
                  </Typography>
                  <Typography variant="caption" color="secondary.contrastText">
                    {formatCpfCnpj(user?.store?.document || "")}
                  </Typography>
                </Stack>
              </Stack>
              <IconChevronUp size={18} />
            </Stack>
          )}
        </>
      )}
      <Menu
        anchorEl={anchorEl}
        id="account-menu"
        open={Boolean(anchorEl)}
        onClose={handleClose}
        onClick={handleClose}
        slotProps={{
          paper: {
            elevation: 0,
            sx: {
              overflow: "visible",
              filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
              borderRadius: 2,
              minWidth: 350,
              p: 2,
              mt: 1.5,
              ml: 5,
              "& .MuiAvatar-root": {
                width: 32,
                height: 32,
                ml: -0.5,
                mr: 1,
              },
            },
          },
        }}
        transformOrigin={{ horizontal: "left", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      >
        <Stack sx={{ px: 2, mb: 1 }}>
          <Stack
            sx={{
              flexDirection: "row",
              alignItems: "center",
              gap: 1,
            }}
          >
            <Typography variant="subtitle1" fontWeight={700}>
              Trocar filial
            </Typography>
          </Stack>
        </Stack>
        <Divider />
        {branchs.map((store: any) => (
          <MenuItem onClick={() => onSelect(store?.id)} sx={{ paddingY: 1.5 }}>
            <ListItemIcon>
              <IconBuildings fontSize="small" />
            </ListItemIcon>
            {store?.name}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default BranchSelect;
